import { useSelector } from "react-redux";
import { FilterModalLT } from "./show-traditions/filter-modal";

export const FilterModalWrapper = ({ data, isSmallScreen, isVisible }) => {
  const { treeIsOpen } = useSelector((state) => state.summaryTree);
  return (
    <FilterModalLT
      data={data}
      className={`${
        (!isSmallScreen || treeIsOpen) && isVisible ? "w-full" : "w-0"
      }  sm:w-[40rem] sm:mr-22 ${
        isSmallScreen && !treeIsOpen ? "top-0" : "top-30"
      } sm:top-50 right-0`}
      style={{
        zIndex: isSmallScreen ? "110" : 10,
        position: "fixed",
        maxHeight:
          (isSmallScreen && !treeIsOpen) || !isVisible ? "0px" : "100vh",
        overflow: "hidden",
      }}
    />
  );
};
